import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppRoutes from "@command-center-app/routes/AppRoutes";
import { useEffect } from "react";
import { validateAuthentication } from "./services/auth.service";
import { useNavigate } from "react-router-dom";
import { PostLogin } from ".";
import { useDispatch } from "react-redux";
import { setToken, setUser } from "./redux/slices/authSlice";

function App() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      const { authToken = "", userData = null }: PostLogin =
        (await validateAuthentication(navigate)) as PostLogin;
      if (authToken && userData) {
        dispatch(setUser(userData));
        dispatch(setToken(authToken));
      }
    })();
  });
  return (
    <>
      <AppRoutes />
      {/* ToastContainer goes here ONCE */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light" // or "dark" to match MUI theme
      />
    </>
  );
}

export default App;
